import React from 'react';
import LoadingIndicator from '../../components/shared/LoadingIndicator/LoadingIndicator';
import TrackedWebsiteSelector from './TrackedWebsiteSelector';
import DashboardSettingsTabs from './tabs/DashboardSettingsTabs';
import { useFetchWebsiteIndexEntriesQuery } from '../../deepAnalysis/websiteIndexEntry/service';
import useGetCurrentWebsite from '../../deepAnalysis/websiteIndexEntry/hooks/useGetCurrentWebsite';
import './DashboardSettings.less';


type Props = {
    section?: string;
};


export default function DashboardSettings({ section }: Props) {
    const { website, isLoading: isLoadingSelectedWebsite } = useGetCurrentWebsite();
    const { data: websiteIndexEntries, isLoading: isLoadingWebsiteIndexEntries } = useFetchWebsiteIndexEntriesQuery();
    const isLoading = isLoadingSelectedWebsite || isLoadingWebsiteIndexEntries;

    if (isLoading) {
        return <LoadingIndicator />;
    }

    return (
        <>
            <div className="dashboard-settings-header">
                <TrackedWebsiteSelector
                    trackedWebsites={websiteIndexEntries ? websiteIndexEntries : []}
                    selectedWebsite={website}
                />
            </div>

            <DashboardSettingsTabs selectedWebsite={website} section={section} />
        </>
    );
}
